import axios from 'axios'
import { getToken } from '~/redux/user/tokens'

const getCountryCode = (countryCode) => {
  if (countryCode)
  return Promise.resolve(countryCode)

return getToken().then(token => {
  return axios({
    url: 'https://api-internal-us-east-1.viewlift.com/ip/ipgeolocator', // todo: hardcoded for now
    baseURL: window.settings.apiBaseUrl,
    method: 'POST',
    params: { 'site': window.settings.internalName },
    headers: {
      'Authorization': token,
      'Content-Type': 'application/json',
      'x-api-key': window.settings.baseAPIKey
    },
  }).then( res =>{
    return res.data.countryisocode
  })
})
}

export default getCountryCode;
